<template>
  <base-show :fields="fields" :resourceName="resourceName" :pk="pk" :breadcrumbs="breadcrumbs"
             :disableImport="isProvider && !permissionAll"
             :disableEdit="isProvider && !permissionMakerEdit">
    <template v-slot:actions.remove>
      <span v-if="authAccountId === pk" />
    </template>
    <template slot="recipeCount" slot-scope="{ input }">
      公開:{{ input.recipe_publish }}件 非公開:{{ input.recipe_un_publish }}件
    </template>
    <template slot="productCount" slot-scope="{ input }">
      公開:{{ input.product_publish }}件 非公開:{{ input.product_un_publish }}件
    </template>
    <template slot="categories" slot-scope="{ input }">
      <!-- <span>{{ input }} </span> -->
      <span>{{ showCategories(input) }} </span>
    </template>
    <template slot="logo" slot-scope="{ input }">
      <img v-if="input" :src="input" style="max-height: 200px" />
    </template>
  </base-show>
</template>

<script>
export default {
  props: {
    pk: {
      type: String,
      required: true
    }
  },
  data() {
    const vm = this;
    return {
      resourceName: "makers",
      fields: [
        [
          {
            label: "メーカーID",
            name: "maker_id",
            long: true
          },
          {
            label: "企業名",
            name: "maker_name"
          },
          {
            label: "企業ロゴ",
            name: "logo",
            type: "custom",
          },
          {
            label: "紹介文言",
            name: "description"
          },
          {
            label: "公式HP",
            name: "website_url",
            long: true
          },
          {
            label: "契約プラン",
            name: "plan_num",
            optionType: "common/plans",
            render(value) {
              return vm.optionName("common/plans", value);
            },
            long: true
          },
          {
            label: "レシピ数",
            name: "recipeCount",
            type: "custom",
            long: true
          },
          {
            label: "商品数",
            name: "productCount",
            type: "custom",
            long: true
          },
          {
            label: "取り扱いカテゴリ",
            name: "categories",
            type: "custom",
            optionType: "common/product_medium_categories",
            long: true
          },
          {
            label: "契約開始日",
            name: "contract_start_from"
          },
          {
            label: "契約更新日",
            name: "contract_update_at"
          },
          {
            label: "契約終了日",
            name: "contract_end_at"
          },
          {
            label: "削除ステータス",
            name: "maker_status"
          }
        ]
      ]
    };
  },
  computed: {
    breadcrumbs() {
      if(this.isProvider) {
        return [
          {
            text: "メーカー管理",
            disabled: false,
            to: `/${this.resourceName}`
          },
          {
            text: "メーカー詳細",
            disabled: true
          }
        ];
      }else{
        return [
          {
            text: "企業情報",
            disabled: true
          }
        ];
      }
    },
    authAccountId() {
      return this.$store.getters[`auth/accountId`];
    },
    optionName() {
      return (optionName, value) => {
        const options =
          this.$store.getters[`${optionName}/options/options`] || [];
        return (options.find(v => v.value === value) || {}).label;
      };
    },
    isProvider() {
      return this.$store.getters[`auth/isProvider`];
    },
    permissionAll() {
      return this.$store.getters[`auth/permissionAll`];
    },
    permissionMakerEdit() {
      return this.$store.getters[`auth/permissionMakerEdit`];
    }
  },
  methods: {
    showCategories(value) {
      const categories = [];
      if(Array.isArray(value)) {
        value.forEach(v => {
          categories.push(v.name);
        });
        return categories.join(',');
      }
    }
  },
  created() {
    if(this.isProvider) {
      this.fields[0].push(
        {
          label: "フリー欄",
          name: "additional_comments",
          width: "100%",
          long: true
        }
      )
    }
  }
};
</script>
